import React from 'react';
import { Link } from 'react-router-dom';
import { useLocation, useNavigate } from 'react-router-dom';

const Breadcrumbs = ({ campaignData }) => {
    const location = useLocation();
    const navigate = useNavigate();

    // Get the current path and build breadcrumbs based on navigation history
    const getBreadcrumbs = () => {
        const pathMap = {
            '/campaign-summary': 'Campaign Summary',
            '/category': 'Category',
            '/personalization-campaign': campaignData?.campaign_name || 'Untitled Campaign',
            '/meta-ads-personalization': 'Meta Ads Personalization',
            '/landing-page-optimization': 'Landing Page Optimization',
            '/custom-campaign-personalization': 'Custom Campaign Personalization',
            '/ai-response-editor': 'AI Response Editor'
        };

        // Get the previous page from location state
        const previousPage = location.state?.previousPage;
        const breadcrumbs = [];

        // Always add Campaign Summary as the first item if we're not on the summary page
        if (location.pathname !== '/campaign-summary') {
            breadcrumbs.push({
                path: '/campaign-summary',
                label: 'Campaign Summary'
            });
        }

        // Add intermediate pages based on navigation path
        if (location.pathname === '/landing-page-optimization' && previousPage === 'personalization-campaign') {
            // Add Personalization Campaign as intermediate step
            breadcrumbs.push({
                path: '/personalization-campaign',
                label: campaignData?.campaign_name || 'Untitled Campaign',
                isIntermediate: true
            });
        } else if (location.pathname === '/personalization-campaign' && previousPage === 'category') {
            // Add Category as intermediate step when coming from category selection
            breadcrumbs.push({
                path: '/category',
                label: 'Category',
                isIntermediate: true
            });
        }

        // Remove the current page from breadcrumbs - we only want to show the path that led here
        const currentPage = {
            label: pathMap[location.pathname] || 'Current Page',
            isCurrentPage: true
        };
        
        return [...breadcrumbs, currentPage];
    };

    const breadcrumbs = getBreadcrumbs();

    if (breadcrumbs.length === 0) return null;

    return (
        <div className="breadcrumbs-container mb-3 mx-2" style={{ fontSize: '0.9rem' }}>
            <svg className='me-2' width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.25 19.25H5.68333C4.65657 19.25 4.14319 19.25 3.75102 19.0502C3.40605 18.8744 3.12559 18.5939 2.94982 18.249C2.75 17.8568 2.75 17.3434 2.75 16.3167V2.75M6.41667 9.625V16.0417M10.5417 5.04167V16.0417M14.6667 9.625V16.0417M18.7917 5.04167V16.0417" stroke="#535353" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            {breadcrumbs.map((crumb, index) => (
                <React.Fragment key={crumb.path || 'current'}>
                    {index > 0 && (
                        <span className="mx-2" style={{ color: '#000' }}>›</span>
                    )}
                    {crumb.isCurrentPage ? (
                        <span style={{ color: '#666', cursor: 'none' }}>{crumb.label}</span>
                    ) : (
                        <Link 
                            to={crumb.path} 
                            state={campaignData ? { 
                                campaignData,
                                previousPage: crumb.isIntermediate ? 'campaign-summary' : location.pathname
                            } : undefined}
                            style={{ 
                                color: '#000',
                                textDecoration: 'underline',
                                textDecorationColor: '#000'
                            }}
                        >
                            {crumb.label}
                        </Link>
                    )}
                </React.Fragment>
            ))}
        </div>
    );
};

export default Breadcrumbs; 